module.exports = __webpack_public_path__ + "static/40-93d0d22537681f90be90f4992220d7f1.jpg";